import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=33214846&"
import script from "./invite.vue?vue&type=script&lang=ts&"
export * from "./invite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports